import React from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import ExcelIcon from '../_icons/ExcelIcon';

const StyledExcelButton = styled(Button)({
  minWidth: '90px',
  height: '35px',
  padding: '6px 14px',
  borderRadius: '6px',
  border: '1px solid #217346',
  background: '#217346',
  color: '#fff',
  fontSize: '13px',
  fontWeight: 500,
  boxShadow: 'none',
  gap: '6px',
  whiteSpace: 'nowrap',
  flexShrink: 0,
  '&:hover': {
    background: '#217346',
    color: '#fff',
    boxShadow: 'none',
  },
  '&:disabled': {
    border: '1px solid #ccc',
    background: '#ccc',
    color: '#fff',
    opacity: 0.6,
  },
});

export const CommonExcelButton = React.forwardRef(({ children, ...props }, ref) => {
  return (
    <StyledExcelButton variant="outlined" ref={ref} {...props}>
      <ExcelIcon size={18} className="excel-icon" />
      {children}
    </StyledExcelButton>
  );
});

export default CommonExcelButton;
